var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{attrs:{"value":_vm.data,"language":_vm.ru,"format":_vm.customFormatter},on:{"selected":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }